var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"min-vh-100"},[_c('top-menu'),_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',[_c('router-view')],1)])]),_c('footer-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }